export default "__VITE_ASSET__$iUtEKUf__"